<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li class="tabLi" v-for="(data, $index) in langData" :key="$index" :class="{ 'active': $index == 0 }">
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a :class="true ? 'tab' + $index : ''" data-toggle="tab" :href="true ? '#tab-' + $index : ''" aria-expanded="true" @click="showTab($event, $index)">{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form :model="membershipDetail" ref="membershipDetail" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div :id="'tab-' + index" v-for="(langItem, index) in membershipDetail.langMap" :key="index" class="tab-pane">
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">Membership type</label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="membershipCategoryId"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-select v-model="membershipDetail.membershipCategoryId" clearable>
                      <el-option v-if="item.categoryType" v-for="item in categoryList" :key="item.id" :label="item.categoryCode" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Membership name </label>
                <div class="col-sm-4">
                  <el-form-item
                    :prop="'langMap.' + index + '.membershipName'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="langItem.membershipName" show-word-limit :maxlength="100"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Membership card image </label>
                <div class="col-sm-10">
                  <el-form-item
                    :prop="'langMap.' + index + '.membershipCardImage'"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'change',
                    }"
                  >
                    <el-input v-model="langItem.membershipCardImage" style="display: none"></el-input>
                    <file-upload :fileUploadUrl="fileUploadUrl" :limit="5" v-model="langItem.membershipCardImage">
                      <template v-slot:sizeError>
                        <div style="color: red">Size error!</div>
                      </template>
                      <template v-slot:dimensionError>
                        <div style="color: red">Dimension Error!</div>
                      </template>
                      <template v-slot:sizeHint>
                        <div style="font-size: 12px">(Suggested Size: 150 X 112; ratio 4:3)</div>
                        <div>Max 5 MB.</div>
                      </template>
                    </file-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Member ID </label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="memberId"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="membershipDetail.memberId" show-word-limit :maxlength="100"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Disable renewal reminder </label>
                <div class="col-sm-4" style="padding-top: 7px">
                  <el-checkbox v-model="membershipDetail.disableReminder"></el-checkbox>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Order</label>
                <div class="col-sm-4">
                  <el-form-item
                    prop="orderBy"
                    :rules="{
                      required: true,
                      message: $t('message.required'),
                      trigger: 'blur',
                    }"
                  >
                    <el-input v-model="membershipDetail.orderBy" show-word-limit :maxlength="100"></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label"> Remark </label>
                <div class="col-sm-4">
                  <el-input v-model="membershipDetail.remark" show-word-limit :maxlength="500"></el-input>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div
                      class="btn btn-primary"
                      v-if="(!$route.query.id && checkPermission('Membership management add')) || ($route.query.id && checkPermission('Membership management update'))"
                      @click="checkEvent()"
                    >
                      {{ $t("message.Save") }}
                    </div>
                    <div class="btn btn-white" @click="showWarning()">{{ $t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import fileupload from "../components/common/fileupload";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      membershipDetail: {
        "membershipCategoryId": "",
        "status": 1,
        "memberId": "",
        "remark": "",
        "orderBy": 0,
        "disableReminder": false,
        "langMap": [
          {
            langCode: "en_US",
            membershipName: "",
            membershipCardImage: "",
          },
          {
            langCode: "zh_CN",
            membershipName: "",
            membershipCardImage: "",
          },
          {
            langCode: "zh_HK",
            membershipName: "",
            membershipCardImage: "",
          },
        ],
      },
      statusObj: [],
      languageObj: [],
      categoryList: [],
      typeObj: [],
      synonyms: "",
    };
  },
  created() {
    this.init();
    this.getCategory();
  },
  watch: {
    membershipDetail: {
      handler: function (val, oldval) {
        this.$store.state.edit = true;
      },
      deep: true,
    },
  },
  components: {
    "file-upload": fileupload,
  },
  mounted() {
    setTimeout(function () {
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    });
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.id = id;
        obj.apiUrl = "/getMembershipDetail";
        var data = await this.$store.dispatch("apiEvent", obj);
        if (!data) return;
        this.$set(this, "membershipDetail", data.data.result);
        var that = this;
        setTimeout(function () {
          that.$store.state.edit = false;
        });
      } else {
      }
      this.setObj();
    },
    async getCategory() {
      let obj = this.getAuthObj();
      obj.apiUrl = "/getMembershipCategoryList";
      var data = await this.$store.dispatch("apiEvent", obj);
      if (!data) return;
      this.$set(this, "categoryList", data.data);
    },
    goBack() {
      this.$router.push({
        path: "/main/membershipManagement",
        query: { ...this.$route.query },
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      }
    },
    checkEvent: function () {
      this.$refs["membershipDetail"].validate(valid => {
        if (valid) {
          this.submit();
        } else {
          // this.$toastr.w("请完成必填项");
          return false;
        }
      });
    },
    async submit() {
      let obj = this.getAuthObj();
      if (this.$route.query.id) {
        this.membershipDetail.id = this.$route.query.id;
      }
      obj.membership = {
        "id": this.membershipDetail.id,
        "membershipCategoryId": this.membershipDetail.membershipCategoryId,
        "status": this.membershipDetail.status,
        "memberId": this.membershipDetail.memberId,
        "disableReminder": this.membershipDetail.disableReminder,
        "orderBy": this.membershipDetail.orderBy,
        "remark": this.membershipDetail.remark,
        "langMap": this.membershipDetail.langMap,
      };
      obj.membership = JSON.stringify(obj.membership);
      if (this.$route.query.id) {
        obj.apiUrl = "/updateMembership";
        var data = await this.$store.dispatch("apiEvent", obj);
      } else {
        obj.apiUrl = "/addMembership";
        var data = await this.$store.dispatch("apiEvent", obj);
      }
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.state.edit = false;
        this.goBack();
      }
    },
    setObj: function () {},
    changeTab: function (id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function ($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  },
};
</script>
